
import request from '@/utils/server'
 
//  组织列表
export function getOrgList(query) {
    return request({
      url: '/user/getOrgList',
      method: 'get',
      params: query
    })
  }
// 新增人员
export function addUser(data) {
    return request({
      url: '/user/addUser',
      method: 'POST',
      data:data
    })
  }
  // 人员列表
  export function getUserList(query) {
    return request({
      url: '/user/getUserList',
      method: 'get',
      params: query
    })
  }
  // 删除
  export function delUser(data) {
    return request({
      url: '/user/delUser',
      method: 'POST',
      data:data
    })
  }
  // 修改
  export function editUser(data) {
    return request({
      url: '/user/editUser',
      method: 'POST',
      data:data
    })
  }
  // 重置密码
   export function updatePassword(data) {
    return request({
      url: '/user/updatePassword',
      method: 'POST',
      data:data
    })
  }
  // 上传健康证
     export function uploadHealthCertificate(data) {
    return request({
      url: '/user/uploadHealthCertificate',
      method: 'POST',
      data:data
    })
  }